import baseRoute from '../baseRoute';

export default `${baseRoute}/materialJobMarkupHistory` as const;
